import moment from 'moment';

export const formatCurrency = (value: string | undefined | number): string => Intl.NumberFormat('en-US', { currency: 'USD', style: 'currency' }).format(Number(value));

export const parseCurrency = (value: string | undefined = ''): number => Number(value.replace(/\$\s?|(,*)/g, ''));

export const formatDate = (value: string | undefined | number): string => moment(value).format('l');

export const formatLongDate = (value: string | undefined | number): string => moment(value).format('l') + ' ' + moment(value).format('LT');
